<template>
  <section>
    <v-card>
      <div class="row pt-5 pb-5">
        <div class="col-12 ml-5 mt-5">
          <h3>Download com intervalo de datas</h3>
        </div>
      </div>
      <div class="row mt-5 p-5 ml-5">
        <div class="col-4">
          <label>Inicio</label>
          <date-picker
            v-model="dateTimePickerDe"
            valueType="format"
            style="margin-left:15px"
          ></date-picker>
        </div>
      </div>
      <div class="row p-5 ml-5 mt-5">
        <div class="col-4">
          <label>Fim</label>
          <date-picker
            v-model="dateTimePickerAte"
            style="margin-left:15px"
            valueType="format"
          ></date-picker>
        </div>
      </div>
      <div class="row pb-5 ml-5 mt-5">
        <div
          v-if="dateTimePickerDe != '' && dateTimePickerAte != ''"
          class="col-4"
        >
          <v-btn class="buttonDownload" @click="downloadCsvDatas()"
            >Download de
            {{ dateTimePickerDe + " a " + dateTimePickerAte }}</v-btn
          >
        </div>
      </div>
      <div>
        <div></div>
      </div>
    </v-card>
    <v-card class="table-container mt-5">
      <template>
        <v-data-table
          :headers="headersIndividual"
          :items="individual"
          :search="search"
          sort-by="name"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-toolbar-title class="section-title"
                >Formulário de Registo</v-toolbar-title
              >
              <v-spacer></v-spacer>

              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Procurar"
                class="mr-2 mb-4"
                single-line
                hide-details
              ></v-text-field>

              <v-btn
                color="#90A99C"
                fab
                dark
                small
                class="plus-btn mb-2 mr-2"
                @click="export_excel()"
              >
                <v-icon>mdi mdi-download</v-icon>
              </v-btn>
            </v-toolbar>
          </template>
        </v-data-table>
      </template>
      <template>
        <div class="text-center">
          <v-snackbar v-model="snackbar">
            Lead atualizada com sucesso!
          </v-snackbar>
        </div>
      </template>
    </v-card>
  </section>
</template>

<script>
  import { json2excel } from "js2excel";
  // import Papa from "papaparse";
  import DatePicker from "vue2-datepicker";
  import "vue2-datepicker/index.css";
  export default {
    components: {
      DatePicker,
    },
    name: "pages",
    data: () => ({
      search: "",
      dataJsonCosmeticaTransformado: [],
      headersIndividual: [
        { text: "Email", sortable: true, value: "email", width: "400px" },
        { text: "Género", value: "genero", width: "200px" },
        {
          text: "Data de Nascimento",
          value: "data_nascimento",
          width: "200px",
        },
        {
          text: "Código Postal",
          sortable: true,
          value: "cod_postal",
          width: "200px",
        },
        {
          text: "UTM Source",
          sortable: true,
          value: "utm_source",
          width: "200px",
        },
        {
          text: "UTM medium",
          sortable: true,
          value: "utm_medium",
          width: "200px",
        },
        {
          text: "UTM campaign",
          sortable: true,
          value: "utm_campaign",
          width: "200px",
        },
        {
          text: "Recruitment",
          sortable: true,
          value: "recruitment",
          width: "200px",
        },
        { text: "Data", sortable: true, value: "dt_created", width: "200px" },
      ],

      snackbar: false,
      individual: [],
      dateTimePickerDe: "",
      dateTimePickerAte: "",
    }),

    async mounted() {
      await this.initialize();
    },

    methods: {
      isBefore(fromDateStr, toDateStr) {
        var fromDate = new Date(fromDateStr);
        var toDate = new Date(toDateStr);

        return fromDate.getTime() < toDate.getTime();
      },
      async downloadCsvDatas() {
        var data = this.individual;
        var dataDe = this.dateTimePickerDe;
        var dataAte = this.dateTimePickerAte;
        if (!this.isBefore(dataDe, dataAte)) {
          return;
        }
        dataDe = new Date(dataDe);
        dataAte = new Date(dataAte);

        data = data.filter((obj) => {
          const time = new Date(obj.dt_created);
          return time >= dataDe && time <= dataAte;
        });

        for (let i = 0; i < data.length; i++) {
          const currentDate = data[i].data_nascimento;

          // Check if currentDate is in "yyyy-mm-dd" format
          const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
          if (dateRegex.test(currentDate)) {
            // Convert the date to "dd-mm-yyyy" format
            const parts = currentDate.split("-");
            const formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`;

            // Update the data_nascimento property
            data[i].data_nascimento = formattedDate;
            data[i].dt_created = data[i].dt_created.split(" ")[0];
          }
        }
        try {
          json2excel({
            data,
            name: "Export_Leads-NetSonda",
            formateDate: "yyyy-mm-dd",
          });
        } catch (e) {
          alert("export error");
        }
      },
      export_excel: async function() {
        var data = this.individual;
        for (let i = 0; i < data.length; i++) {
          const currentDate = data[i].data_nascimento;

          // Check if currentDate is in "yyyy-mm-dd" format
          const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
          if (dateRegex.test(currentDate)) {
            // Convert the date to "dd-mm-yyyy" format
            const parts = currentDate.split("-");
            const formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`;

            // Update the data_nascimento property
            data[i].data_nascimento = formattedDate;
            data[i].dt_created = data[i].dt_created.split(" ")[0];
          }
        }
        try {
          json2excel({
            data,
            name: "Export_Leads-NetSonda",
            formateDate: "yyyy-mm-dd",
          });
        } catch (e) {
          alert("export error");
        }
      },
      export_excel_cosmetica: async function() {
        var _this = this;
        var data = _this.dataJsonCosmeticaTransformado;
        try {
          json2excel({
            data,
            name: "Export_Leads-COSMETICA",
            formateDate: "yyyy-mm-dd",
          });
        } catch (e) {
          alert("export error");
        }
      },
      async initialize() {
        try {
          // Assuming Vue.js syntax for accessing $store
          let res = await this.$store.dispatch("collectPages", this);

          // Extracting leads from the response
          var leads = Object.values(res);
          const mesesEmPortugues = [
            "Janeiro",
            "Fevereiro",
            "Março",
            "Abril",
            "Maio",
            "Junho",
            "Julho",
            "Agosto",
            "Setembro",
            "Outubro",
            "Novembro",
            "Dezembro",
          ];

          // Setting the 'individual' property with leads
          for (let i = 0; i < leads.length; i++) {
            leads[i].cod_postal = leads[i].cod_postal.toString().slice(0, 4);
            // Crie um objeto Date a partir da string
            var dataObj = new Date(leads[i].dt_created);

            // Obtenha o número do mês (0-11)
            var numeroDoMes = dataObj.getMonth();

            // Lista de nomes dos meses em português

            // Obtenha o nome do mês em português
            var nomeDoMes = mesesEmPortugues[numeroDoMes];
            leads[i].mes = nomeDoMes;
          }
          this.individual = leads;
          console.log(this.individual);
        } catch (error) {
          console.error("Error during initialization:", error);
        }
      },
    },
  };
</script>
